import React, { useEffect, useState } from "react";
import { CookiesProvider, withCookies } from "react-cookie";

import Header from "./Header";
import Footer from "./Footer";

import "styles/app.scss";
import CookieBanner from "./CookieBanner";

const Layout = ({ children, cookies, lang, mapPage }) => {
   const [cookieBanner, setCookieBanner] = useState("");

   const acceptCookieBanner = () => {
      const promiseSetCookie = new Promise((resolve) =>
         resolve(cookies.set("cookiesMalopolska", "active", { path: "/" }))
      );
      promiseSetCookie.then(() => {
         setCookieBanner(false);
      });
   };

   useEffect(() => {
      const isAcceptedCoookie = !!cookies.get("cookiesMalopolska");
      !isAcceptedCoookie && setCookieBanner(true);
   }, [cookies]);

   return (
      <CookiesProvider>
         <Header />
         <main>{children}</main>
         <Footer />
         {cookieBanner && <CookieBanner onClick={acceptCookieBanner} />}
      </CookiesProvider>
   );
};

export default withCookies(Layout);
